import { render, staticRenderFns } from "./SalesOrderFormattedDate.vue?vue&type=template&id=437fa33c&"
import script from "./SalesOrderFormattedDate.vue?vue&type=script&lang=js&"
export * from "./SalesOrderFormattedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports